export default import.meta.ROLLUP_FILE_URL_acbLwnX2KgjAHL5T0Sf5ug